import { render, staticRenderFns } from "./AssignorgroupEdit.vue?vue&type=template&id=eb47b130&"
import script from "./AssignorgroupEdit.vue?vue&type=script&lang=js&"
export * from "./AssignorgroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports